import {
    TradingProcedureListQueryPort
} from '../../../../features/trading-procedure-list/application/ports/trading-procedure-list-query.port';
import { inject } from '@angular/core';
import {
    TradingProcedureAdminApi,
    TradingProcedureRegistryInfoResponseDto,
    TradingProcedureDocumentAdminApi
} from '@tradgine/data-access/tradgine-data';
import { Observable, map } from 'rxjs';
import { Result } from '@hereisyourgitanton/core';
import { TradingProcedure } from '../../../domain/trading-procedure/models/trading-procedure.model';
import { toTradingProcedure } from '../mappers/trading-procedure.mapper';

export class TradingProcedureListQueryAdapter implements TradingProcedureListQueryPort {
    private readonly tradingProcedureAdminApi = inject(TradingProcedureAdminApi);
    private readonly tradingProcedureDocumentAdminApi = inject(TradingProcedureDocumentAdminApi);

    getAll(): Observable<Result<TradingProcedure[], Error>> {
        return this.tradingProcedureAdminApi.getAll().pipe(
            map(
                (result) =>
                    result
                        .map((tps) => tps.map(toTradingProcedure))
                        .mapErr((err) => new Error('Failed to fetch trading procedures')) // TODO localize or use type error?
            )
        );
    }

    getById(id: number): Observable<Result<TradingProcedure, Error>> {
        return this.tradingProcedureAdminApi.getById(id).pipe(
            map(
                (result) =>
                    result
                        .map(toTradingProcedure)
                        .mapErr((err) => new Error('Failed to fetch trading procedure')) // TODO localize or use type error?
            )
        );
    }

    getRegistryInfo(id: number): Observable<Result<TradingProcedureRegistryInfoResponseDto, Error>> {
        return this.tradingProcedureDocumentAdminApi.getRegistryInfo(id);
    }

    getRegistryFile(id: number): Observable<Result<Blob, Error>> {
        return this.tradingProcedureDocumentAdminApi.getRegistry(id).pipe(
            map((result) => result.mapErr((err) => new Error(err.message)))
        );
    }
}
